import * as React from "react";
const SvgIcMessage = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5 24L9.83 17.9876H1V2H23V17.9876H18.5V24ZM4 14.99H10.77L15.5 18.2704V14.99H20V4.99768H4V14.99Z" fill="currentColor" /></svg>;
export default SvgIcMessage;